var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8.85889L5.5 3.66889M1.27 6.41889L10 11.4689L18.73 6.41889M10 21.5389V11.4589M19 15.4589V7.45889C18.9996 7.10816 18.9071 6.7637 18.7315 6.46005C18.556 6.1564 18.3037 5.90425 18 5.72889L11 1.72889C10.696 1.55335 10.3511 1.46094 10 1.46094C9.64893 1.46094 9.30404 1.55335 9 1.72889L2 5.72889C1.69626 5.90425 1.44398 6.1564 1.26846 6.46005C1.09294 6.7637 1.00036 7.10816 1 7.45889V15.4589C1.00036 15.8096 1.09294 16.1541 1.26846 16.4577C1.44398 16.7614 1.69626 17.0135 2 17.1889L9 21.1889C9.30404 21.3644 9.64893 21.4568 10 21.4568C10.3511 21.4568 10.696 21.3644 11 21.1889L18 17.1889C18.3037 17.0135 18.556 16.7614 18.7315 16.4577C18.9071 16.1541 18.9996 15.8096 19 15.4589Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.0ee6b49a69a946ecb046567f16617d25.svg";
export { ForwardRef as ReactComponent };